<template>
  <layout title="Estabelecimento" :options="options" :rotas="rotas">
    <v-sheet
      :dark="$theme.dark"
      :light="$theme.light"
      class="expande-horizontal sheet-container pt-2"
    >
      <v-flex xs12 class="pr-1" lg3>
        <Filters :filter="filter" />
        <List :filtereds="filtereds" @open-new-establishment="iniciarCadastro" />
        <EmptyList
          :iniciarCadastro="iniciarCadastro"
          v-if="filtereds.length === 0"
        />
        <!-- <v-fab-transition>
          <v-btn
            @click="iniciarCadastro"
            :color="$theme.primary"
            dark
            absolute
            bottom
            right
            fab
            style="bottom: 30px;"
          >
            <v-icon color="#333">mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition> -->
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.lgAndUp" xs12 md9 lg9>
        <ViewForm v-if="get_establishment.new || get_establishment._id" />
      </v-flex>
      <v-dialog
        v-else
        transition="slide-x-transition"
        fullscreen
        :value="get_establishment._id || get_establishment.new ? true : false"
      >
        <v-card>
          <ViewForm />
        </v-card>
      </v-dialog>
    </v-sheet>
  </layout>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      filter: {},
      options: [
        // {
        //   nome: "Novo estabelecimento",
        //   action: this.iniciarCadastro,
        //   icon: "mdi-plus"
        // }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "establishments",
          path: "/establishments"
        }
      ]
    };
  },
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm
  },
  computed: {
    ...mapGetters([
      "get_establishments_filtros",
      "getLoggedUser",
      "get_establishment",
      "get_establishments",
      "getPersonalizedLoading"
    ]),
    filtereds() {
      if (this.filter.search) {
        return this.get_establishments.docs.filter(item => {
          return (
            (item.nome &&
              item.nome
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.email &&
              item.email
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.telefone &&
              item.telefone.includes(this.filter.search.toLowerCase()))
          );
        });
      } else {
        return this.get_establishments.docs;
      }
    }
  },
  methods: {
    excluir_establishment_dialog(item) {
      let text = "Deseja remover este establishment?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_establishment",
        action_value: item
      });
    },
    getLinkById(id) {
      return this.getLinkById[id];
    },
    ...mapActions([
      "abre_modal_view_tenant",
      "listar_tenants",
      "listar_establishments",
      "criar_estoque",
      "listar_establishmentcategorias",
      "criar_establishment",
      "listar_estoques",
      "atualizar_establishment",
      "setPersonalizedLoading",
      "createConfirmAction"
    ]),
    criarOuAtualizar() {
      if (this.get_establishment._id) {
        this.atualizar_establishment();
      } else {
        this.criar_establishment();
      }
    },
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_establishment", { new: true, address: {} });
      this.$store.commit("setLinks", []);
      this.setPersonalizedLoading("animate__fadeInUp");
    },
    createOrUpdate() {
      if (this.$refs.form.validate()) {
        if (this.get_establishment._id) {
          this.atualizar_establishment();
        } else {
          this.criar_establishment();
        }
      }
    }
  },
  created() {
    this.listar_establishments();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
</style>
